import { Gamepads, HostGamepadRaw } from '../../components/widgets/Gamepads';

export const Inputs = () => {

  return (
    <div className='flex flex-1 flex-col items-center overflow-y-auto px-10 py-4'>
      <div className='flex h-fit w-full max-w-[1280px] flex-col gap-8 md:h-dvh md:flex-row md:overflow-hidden'>
        <section className='flex flex-none flex-col space-y-8 overflow-y-auto md:w-72 lg:w-[24rem]'>
          <div className='space-y-4'>
            <HostGamepadRaw />
          </div>
        </section>

        <section className='flex w-full flex-1'>
          <div className='flex w-full flex-col space-y-4'>
            <div className='flex items-center space-x-4'>
              <Gamepads />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
